<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="none"
  >
    <slot />
  </svg>
</template>

<script>
export default {
  name: 'graphicBase',
  props: {
    width: {
      type: [Number, String],
      default: '100px'
    },
    height: {
      type: [Number, String],
      default: '100px'
    },
    viewBox: {
      type: [String],
      default: '0 0 225 142'
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
